var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationEmptyErrorState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "336px",
    height: "228px",
    viewBox: "0 0 336 228",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NLBase_airport-Empty-state",
    transform: "translate(-472.000000, -184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(0.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(472.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(97.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    fill: "#ECECEC",
    cx: 72.5,
    cy: 138,
    rx: 72.5,
    ry: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1653781,2 L8,2 C6.34314575,2 4.84314575,2.67157288 3.75735931,3.75735931 C2.67157288,4.84314575 2,6.34314575 2,8 L2,132 C2,133.656854 2.67157288,135.156854 3.75735931,136.242641 C4.84314575,137.328427 6.34314575,138 8,138 L92,138 C93.6568542,138 95.1568542,137.328427 96.2426407,136.242641 C97.3284271,135.156854 98,133.656854 98,132 L98,38.4328165 C98,36.8278779 97.357007,35.2898395 96.2147259,34.1624435 L65.380104,3.72962697 C64.257232,2.62138717 62.7430462,2 61.1653781,2 Z",
    id: "Rectangle",
    stroke: "#BDBDBD",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5-Copy",
    fill: "#F5F5F5",
    transform: "translate(82.659522, 35.828934) scale(-1, 1) rotate(20.000000) translate(-82.659522, -35.828934) ",
    points: "99.2439098 29.7927108 95.2379727 38.9114092 66.0751338 41.8651579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0012795,2.77520459 L64.0012795,29 C64.0012795,30.6568542 64.6728524,32.1568542 65.7586388,33.2426407 C66.8444252,34.3284271 68.3444252,35 70.0012795,35 L96.7997851,35 L64.0012795,2.77520459 Z",
    id: "Rectangle-5",
    stroke: "#BDBDBD",
    strokeWidth: 4,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(32.000000, 60.000000)",
    fill: "#BDBDBD"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    cx: 3,
    cy: 4,
    rx: 3,
    ry: 4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#BDBDBD",
    x: 32,
    y: 100,
    width: 36,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(45.000000, 78.000000)",
    fill: "#BDBDBD"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy",
    x: 0,
    y: 6,
    width: 10,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy-2",
    transform: "translate(2.000000, 5.000000) rotate(90.000000) translate(-2.000000, -5.000000) ",
    x: -3,
    y: 3,
    width: 10,
    height: 4,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(57.000000, 58.000000)",
    fill: "#BDBDBD"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy",
    transform: "translate(6.000000, 6.000000) rotate(45.000000) translate(-6.000000, -6.000000) ",
    x: 0,
    y: 4,
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy-2",
    transform: "translate(6.000000, 6.000000) rotate(-45.000000) translate(-6.000000, -6.000000) ",
    x: 0,
    y: 4,
    width: 12,
    height: 4,
    rx: 2
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M245.714844,37.0351562 C248.808594,37.0351562 251.462891,35.9277344 253.677734,33.7128906 C255.892578,31.4980469 257,28.84375 257,25.75 C257,22.796875 255.980469,20.2480469 253.941406,18.1035156 C251.902344,15.9589844 249.441406,14.78125 246.558594,14.5703125 C245.785156,10.6328125 243.851562,7.38085938 240.757812,4.81445312 C237.664062,2.24804688 234.078125,0.96484375 230,0.96484375 C226.835938,0.96484375 223.917969,1.80859375 221.246094,3.49609375 C218.574219,5.18359375 216.5,7.3984375 215.023438,10.140625 C211.648438,10.4921875 208.800781,11.9511719 206.480469,14.5175781 C204.160156,17.0839844 203,20.0898438 203,23.5351562 C203,27.2617188 204.318359,30.4433594 206.955078,33.0800781 C209.591797,35.7167969 212.773438,37.0351562 216.5,37.0351562 L216.5,37.0351562 L245.714844,37.0351562 Z",
    id: "c",
    fill: "#ECECEC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.476562,174.023438 C330.539062,174.023438 332.308594,173.285156 333.785156,171.808594 C335.261719,170.332031 336,168.5625 336,166.5 C336,164.53125 335.320312,162.832031 333.960938,161.402344 C332.601562,159.972656 330.960938,159.1875 329.039062,159.046875 C328.523438,156.421875 327.234375,154.253906 325.171875,152.542969 C323.109375,150.832031 320.71875,149.976562 318,149.976562 C315.890625,149.976562 313.945312,150.539062 312.164062,151.664062 C310.382812,152.789062 309,154.265625 308.015625,156.09375 C305.765625,156.328125 303.867188,157.300781 302.320312,159.011719 C300.773438,160.722656 300,162.726562 300,165.023438 C300,167.507812 300.878906,169.628906 302.636719,171.386719 C304.394531,173.144531 306.515625,174.023438 309,174.023438 L309,174.023438 L328.476562,174.023438 Z",
    id: "c",
    fill: "#ECECEC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.953125,128.046875 C61.078125,128.046875 64.6171875,126.570312 67.5703125,123.617188 C70.5234375,120.664062 72,117.125 72,113 C72,109.0625 70.640625,105.664062 67.921875,102.804688 C65.203125,99.9453125 61.921875,98.375 58.078125,98.09375 C57.046875,92.84375 54.46875,88.5078125 50.34375,85.0859375 C46.21875,81.6640625 41.4375,79.953125 36,79.953125 C31.78125,79.953125 27.890625,81.078125 24.328125,83.328125 C20.765625,85.578125 18,88.53125 16.03125,92.1875 C11.53125,92.65625 7.734375,94.6015625 4.640625,98.0234375 C1.546875,101.445312 0,105.453125 0,110.046875 C0,115.015625 1.7578125,119.257812 5.2734375,122.773438 C8.7890625,126.289062 13.03125,128.046875 18,128.046875 L18,128.046875 L56.953125,128.046875 Z",
    id: "c",
    fill: "#ECECEC",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyErrorState);
export default __webpack_public_path__ + "static/media/illustration_empty-error_state.4e61be4f9e041b74a847b3d9deafbe8d.svg";
export { ForwardRef as ReactComponent };